import { HTMLThemeElement } from '@archetype-themes/custom-elements/theme-element';

class QuizResults extends HTMLThemeElement {
  constructor() {
    super();
    this.onRetryQuiz = this.onRetryQuiz.bind(this);

    const params = window.location.search.replace('?', '').split('&');
    let tags;
    params.forEach((param) => {
      const pieces = param.split('=');
      if (pieces[0] === 'tags') {
        tags = pieces[1];
      }
    });

    if (!tags) {
      this.noResults('');
    } else {
      tags = decodeURI(tags).replaceAll('%2C', ',');
      this.tags = tags;
      this.fetchResults(tags);
    }
  }

  connectedCallback() {
    this._cacheElements();
    this._bindEvents();
  }

  disconnectedCallback() {
    this._unbindEvents();
  }

  _cacheElements() {
    this.resultsContainer = this.querySelector('#results-container');
    this.retryButton = this.querySelector('#retry-quiz-button');
    this.addToCartButtons = this.querySelectorAll('.add-to-cart-button');
  }

  _bindEvents() {
    if (this.retryButton) {
      this.retryButton.addEventListener('click', this.onRetryQuiz);
    }
  }

  _unbindEvents() {
    if (this.retryButton) {
      this.retryButton.removeEventListener('click', this.onRetryQuiz);
    }
  }

  fetchResults(tags) {
    const url = `https://searchanise.com/getresults?api_key=4S7N6n9z4y&output=json&suggestionsMaxResults=10&maxResults=30&restrictBy[tags]=${tags}&pages=false&categories=false&facets=true`;
    const config = {
      method: 'GET',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    fetch(`${url}`, { config })
      .then((response) => response.json())
      .then((parsedResponse) => {
        if (parsedResponse.totalItems >= 1) {
          this.printResults(parsedResponse);
        } else {
          this.noResults(tags);
        }
      })
      .catch((e) => {
        console.error(e);
        this.noResults();
      });
  }

  noResults(tags) {
    this.fetchResults('pet-safe');
    this.querySelector('h1').innerText =
      'Your results are in! These plants are an (almost) perfect match.';
  }

  printResults(results) {
    if (!results.items || !results.items.length) {
      console.warn('No items found in results:', results);
      this.noResults(this.tags);
      return;
    }

    const container = this.resultsContainer;
    container.innerHTML =
      '<h4 class="h4" style="width: 100%; text-align: center">Loading matches...</h4>'; // add loading message

    // Use the `link` property directly to fetch product views
    const productViewPromises = results.items.map((item, index) => {
      if (!item.link) {
        console.warn(`No link found for product at index ${index}:`, item);
        return Promise.resolve(''); // Skip if no link is found
      }

      const url = `${item.link}?view=grid-item`; // Use the `link` property

      return new Promise((resolve, reject) => {
        window
          .fetch(url, { method: 'GET' })
          .then((response) => {
            response
              .text()
              .then((text) => {
                resolve(text);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((err) => {
            console.error('Error fetching product view:', err);
            reject(err);
          });
      });
    });

    // Render all fetched product views
    Promise.all(productViewPromises)
      .then((productMarkups) => {
        container.innerHTML = ''; // Clear the container
        productMarkups.forEach((markup, index) => {
          if (markup) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = markup;
            container.appendChild(wrapper.firstElementChild);
          }
        });

        container.classList.remove('hidden'); // Unhide the container
      })
      .catch((err) => {
        console.error('Error rendering quiz results:', err);
      });
  }

  onRetryQuiz() {
    const retryUrl = '/';
    window.location.href = retryUrl;
  }
}

customElements.define('quiz-results', QuizResults);